// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","icon":"Header_icon__HQfkY","email":"Header_email__+wLSz"};